// extracted by mini-css-extract-plugin
module.exports = {"footer":"NTIPcwLfbFD9XJ7e0GBYPQ==","copyright":"lh-CwlE4Adm52eCUlkJSjw=="};